import React, { useState } from 'react';
import { Container, Row, Col, Alert, Badge } from 'react-bootstrap';
import SearchHeader from './SearchHeader';
import ProcessTimeline from './ProcessTimeline';

import authHeader from "../../../services/auth-header";
import _db from "../../../services/kiosque-service";

const AuditWrapper = () => {
    const [allLogs, setAllLogs] = useState([]); // Tous les logs du booking
    const [sessions, setSessions] = useState([]); // Logs groupés par session
    const [selectedLogs, setSelectedLogs] = useState(null); // Logs de la session cliquée
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');

    const handleSearch = async (bookNum) => {
        setSearchTerm(bookNum);
        setIsLoading(true);
        setError(null);
        setSelectedLogs(null);

        try {
            const response = await _db.get(`/api/kiosquelogs`, {
                params: { bookNum },
                headers: authHeader()
            });

            if (response.data.length === 0) {
                setError("Aucun log trouvé pour ce booking.");
                setSessions([]);
                return;
            }

            // GROUPEMENT DES LOGS PAR SESSION (Logique de flux)
            const grouped = response.data.reduce((acc, log) => {
                if (!acc[log.sessionId]) {
                    acc[log.sessionId] = {
                        sessionId: log.sessionId,
                        startTime: log.createdAt,
                        isSuccess: false,
                        logs: []
                    };
                }
                acc[log.sessionId].logs.push(log);
                if (log.actionType === 'TRANSACTION_SUCCESS') acc[log.sessionId].isSuccess = true;
                return acc;
            }, {});

            const sortedSessions = Object.values(grouped).sort((a, b) => new Date(b.startTime) - new Date(a.startTime) );
            setSessions(sortedSessions);

            setAllLogs(response.data);
        } catch (err) {
            setError("Erreur lors de la récupération des données.");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="admin-audit-page bg-light mb-3 border border-5 border-secondary rounded-top rounded-2">
            <SearchHeader onSearch={handleSearch} isLoading={isLoading} />

            <Container fluid className="px-4">
                {error && <Alert variant="warning" className="shadow-sm">{error}</Alert>}

                <Row className="g-4">
                    {/* ON N'AFFICHE LE CONTENU QUE SI DES SESSIONS EXISTENT */}
                    {sessions.length > 0 ? (
                        <>
                            {/* --- COLONNE GAUCHE  --- */}                            
                            <Col lg={4}>
                                <div className="card shadow-sm border-0 p-3 bg-white">
                                    <div className="card-header mb-4 bg-white">
                                        <h6 className="text-muted text-uppercase fw-bold m-1 fs-6">
                                            <i className="fa fa-bookmark me-2"></i>BOOKING : <span className="text-dark">{searchTerm.toUpperCase()}</span>
                                        </h6>
                                        <small className="text-muted small">{sessions.length} session(s) trouvée(s)</small>
                                    </div>                                   

                                    <div className="table-responsive">

                                        <table className="table table-hover align-middle mb-0">
                                            <thead className="bg-light">
                                                <tr className="small text-muted text-uppercase" style={{ letterSpacing: '0.5px', fontSize: '11px' }}>
                                                    <th className="ps-3 border-0">Horodatage</th>
                                                    <th className="border-0">Id Session</th>
                                                    <th className="text-center border-0">Résultat</th>
                                                    <th className="pe-3 border-0"></th>
                                                </tr>
                                            </thead>
                                            <tbody className="small">
                                                {sessions.map((s) => {
                                                    // Vérification de l'état actif (Master-Detail)
                                                    const isActive = selectedLogs && selectedLogs[0]?.sessionId === s.sessionId;
                                                    const startDate = new Date(s.startTime);

                                                    return (
                                                        <tr key={s.sessionId}
                                                            className={`${isActive ? 'table-primary shadow-none' : ''}`}
                                                            style={{ cursor: 'pointer', transition: 'all 0.2s' }}
                                                            //onClick={() => setSelectedLogs(s.logs)}
                                                            onClick={() => {
                                                                setSelectedLogs(s.logs);
                                                                window.scrollTo({ top: 0, behavior: 'instant' }); // Remonte la page entière instantanément
                                                            }}
                                                        >
                                                            <td className="ps-3 py-3">
                                                                <div className="d-flex align-items-center">
                                                                    <div className={`rounded-circle me-3 d-flex align-items-center justify-content-center ${isActive ? 'bg-white' : 'bg-light'}`}
                                                                        style={{ width: '35px', height: '35px' }}>
                                                                        <i className={`small fa fa-calendar-o ${isActive ? 'text-primary' : 'text-muted'}`}></i>
                                                                    </div>
                                                                    <div>
                                                                        <div className="fw-bold text-dark small">
                                                                            {startDate.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit', second: '2-digit' })}
                                                                        </div>
                                                                        <div className="text-muted small" style={{ fontSize: '11px', marginTop: '-2px' }}>
                                                                            {startDate.toLocaleDateString(undefined, { day: '2-digit', month: '2-digit', year: 'numeric' })}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </td>

                                                            {/*COLONNE ID SESSION */}
                                                            <td>
                                                                <div className="d-flex align-items-center">
                                                                    <span className="text-dark fw-normal px-2 py-1 small">
                                                                        {s.sessionId.substring(0, 8)}...
                                                                    </span>
                                                                </div>
                                                            </td>

                                                            {/*COLONNE STATUT */}
                                                            <td className="text-center">
                                                                <Badge
                                                                    bg={s.isSuccess ? "success-subtle" : "danger-subtle"}
                                                                    className={`rounded-pill px-2 py-1 border ${s.isSuccess ? 'text-success border-success-subtle' : 'text-danger border-danger-subtle'}`}
                                                                    style={{
                                                                        fontSize: '10px',
                                                                        minWidth: '75px',
                                                                        letterSpacing: '0.5px'
                                                                    }}
                                                                >
                                                                    <i className={`fa ${s.isSuccess ? 'fa-check-circle' : 'fa-times-circle'} me-1`}></i>
                                                                    {s.isSuccess ? 'SUCCÈS' : 'ÉCHEC'}
                                                                </Badge>
                                                            </td>

                                                            {/*COLONNE ACTION */}
                                                            <td className="pe-3 text-end">
                                                                <div className={`rounded-circle d-inline-flex align-items-center justify-content-center shadow-sm ${isActive ? 'bg-primary text-white' : 'bg-white border text-primary'}`}
                                                                    style={{ width: '32px', height: '32px' }}>
                                                                    <i className={`fa ${isActive ? 'fa-chevron-right' : 'fa-search'}`} style={{ fontSize: '12px' }}></i>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>

                                    </div>
                                </div>
                            </Col>

                            {/* --- COLONNE DROITE --- */}
                            <Col lg={8}>
                                {selectedLogs ? (
                                    /* Cas : Détail sélectionné */
                                    <div key={selectedLogs?.sessionId} className="fade-in">
                                        <ProcessTimeline
                                            logs={selectedLogs}
                                            onClose={() => setSelectedLogs(null)}
                                        />
                                    </div>
                                ) : (
                                    /* Cas : Attente de sélection (Placeholder) */
                                    <div className="sticky-top d-flex flex-column align-items-center justify-content-center text-center p-5 bg-white rounded-2 shadow-sm fade-in"
                                        style={{ minHeight: '500px', borderColor: '#dee2e6 !important' }}>

                                        <div className="bg-light rounded-circle d-flex align-items-center justify-content-center mb-4 shadow-sm"
                                            style={{ width: '80px', height: '80px' }}>
                                            <i className="fa fa-road text-primary opacity-50 fa-2x"></i>
                                        </div>

                                        <h5 className="fw-bold text-dark mb-2">Analyse de session</h5>
                                            <p className="text-muted mx-auto" style={{ maxWidth: '350px', fontSize: '14px' }}>
                                            Veuillez sélectionner une session dans la liste à gauche pour consulter son parcours.
                                        </p>

                                        <span className="badge rounded-pill bg-primary-subtle text-primary border border-primary-subtle px-3 py-2 mt-3" style={{ fontSize: '11px' }}>
                                            <i className="fa fa-info-circle me-2"></i>Audit en attente
                                        </span>
                                    </div>
                                )}
                            </Col>
                        </>
                    ) : (
                        /* OPTIONNEL : Message si aucune recherche n'a été faite ou aucun résultat */
                        !isLoading && (
                            <Col lg={12}>
                                <div className="text-center p-5 text-muted">
                                    <i className="fa fa-search fa-3x mb-3 opacity-25"></i>
                                    <p>Lancez une recherche pour analyser les logs d'un booking.</p>
                                </div>
                            </Col>
                        )
                    )}
                </Row>

            </Container>
        </div>
    );
};

export default AuditWrapper;